module.exports = __webpack_public_path__ + "img/ks.63386122.png";